export default __webpack_public_path__ + "421538920b88b57fe455fc1b727a65ba.webp";